const AppVersion = () => {
    return <div id="app_version">Version 1.0.77</div>
}

export default AppVersion;